export default __webpack_public_path__ + "static/media/FCbg.2f01eee2.png";